import createRegistry from "@madappgang/registry";

const registry = createRegistry();
export const registerServices = registry.register;
export default registry.exposeRegistered();
